// The `review` API as a component reads it: there at once when it already
// is, otherwise once it is registered. Its state is read with `useSelect`.
import * as React from 'react';
import type { PiletApi } from '@chess/platform-web';
import { REVIEW_API, type Review } from '@chess/api-review';

export function useReview(app: PiletApi): Review | undefined {
  const [review, setReview] = React.useState<Review | undefined>(() => app.tryGetApi<Review>(REVIEW_API));
  React.useEffect(() => {
    if (review) return;
    let alive = true;
    void app.getApi<Review>(REVIEW_API).then((r) => alive && setReview(r));
    return () => {
      alive = false;
    };
  }, [app, review]);
  return review;
}
